import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'
import React from 'react'

type Props = {
  deleteTarget: { id: number; name: string } | null
  setDeleteTarget: (target: { id: number; name: string } | null) => void
  handleConfirmDelete: () => void
}

export const DeleteGroupModal = (props: Props) => {
  const { deleteTarget, setDeleteTarget, handleConfirmDelete } = props

  return (
    <AlertDialog
      isOpen={!!deleteTarget}
      onClose={() => setDeleteTarget(null)}
      leastDestructiveRef={null}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Delete group
          </AlertDialogHeader>

          <AlertDialogBody>
            Are you sure you want to delete “{deleteTarget?.name}”? This action cannot be
            undone.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={() => setDeleteTarget(null)}>Cancel</Button>
            <Button colorScheme="red" onClick={handleConfirmDelete} ml={3}>
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
